// SupabaseProvider — minimal context wrapper exposing the singleton supabase client.
// In Wave 0 most consumers import `@/lib/supabase` directly; this provider exists
// primarily for testability (vi.mock can swap the entire context).

import { createContext, useContext, type ReactNode } from 'react';
import { supabase as defaultClient } from '@/lib/supabase';

type SupabaseClient = typeof defaultClient;

const SupabaseContext = createContext<SupabaseClient>(defaultClient);

export function SupabaseProvider({
  client = defaultClient,
  children,
}: {
  client?: SupabaseClient;
  children: ReactNode;
}): JSX.Element {
  return <SupabaseContext.Provider value={client}>{children}</SupabaseContext.Provider>;
}

export function useSupabase(): SupabaseClient {
  return useContext(SupabaseContext);
}
